import { sdkRequest } from '@eb/http';
import { eventsDuck, collectionsDuck } from '@eb/redux-destination';

import {
    Collection,
    SearchQuery,
    EventSearchResponse,
    SearchResponse,
} from '../../types';

export const runSearchQuery = async (
    query: SearchQuery,
): Promise<SearchResponse> => {
    const results = await sdkRequest('/api/v3/destination/search/', {
        body: JSON.stringify(query),
        method: 'POST',
    });

    return results;
};

export const getCollectionsForEvent = async ({
    id,
    userCollectionIds,
}: {
    id: string;
    userCollectionIds: string[];
}): Promise<EventSearchResponse> => {
    const queryShape = {
        event_search: {
            q: id,
            only_ids: true,
            aggs: {
                collection: {},
            },
            collections_or: [...userCollectionIds],
        },
    };

    const { events } = await runSearchQuery(queryShape);

    return events;
};

export const saveEvent = async (id: string): Promise<{}> => {
    const response = await eventsDuck.api.saveEvent(id);

    return response;
};

export const unSaveEvent = async (id: string): Promise<{}> => {
    const response = await eventsDuck.api.unsaveEvent(id);

    return response;
};

export const createCollection = async (
    name: string,
    eventId: string,
): Promise<Collection> => {
    const response = await collectionsDuck.api.createCollection(name, [
        eventId,
    ]);

    return response;
};

export const addToCollection = async (
    collectionId: string,
    eventId: string,
): Promise<{}> => {
    const response = await collectionsDuck.api.addToCollection(
        eventId,
        collectionId,
    );

    return response;
};

export const removeFromCollection = async (
    collectionId: string,
    eventId: string,
): Promise<{}> => {
    const response = await collectionsDuck.api.removeFromCollection(
        eventId,
        collectionId,
    );

    return response;
};
